<template>
  <div class="modal fade" role="dialog" style="display:block;" tabindex="-1"
    :class="{ 'show': isOpen }" v-show="isOpen" @keyup.esc="$emit('dismiss')" @click="checkClick($event)">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <slot name="header">{{ title }}</slot>
        </div>
        <div class="modal-body">
          <div ref="modalContent" v-show="!modalOptions.useiFrame">
            <slot></slot>
          </div>
          <iframe ref="iframe" v-if="modalOptions.useiFrame" scrolling="no" width="100%" height="600" style="border: 0;"/>
        </div>
        <div class="modal-footer d-flex justify-content-between">
          <slot name="footer">
            <button type="button" class="btn float-left"
              :class="dismissButtonOptions.class" @click="$emit('dismiss')">
              {{ dismissButtonOptions.label }}
            </button>
            <button type="button" class="btn"
              :class="actionButtonOptions.class" @click="$emit('submit')">
              {{ actionButtonOptions.label }}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    actionButton: {
      type: Object
    },
    dismissButton: {
      type: Object
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    title: String,
    options: Object
  },
  computed: {
    actionButtonOptions () {
      return {
        class: 'btn-success',
        label: 'Confirm',
        disabled: false,
        dismiss: true,
        ...this.actionButton
      }
    },
    modalOptions () {
      return {
        useiFrame: false,
        ...this.options
      }
    },
    dismissButtonOptions () {
      return {
        class: 'btn-default',
        label: 'Dismiss',
        disabled: false,
        dismiss: true,
        ...this.dismissButton
      }
    }
  },
  mounted () {
    if (this.$el.focus) this.$el.focus()
    if (this.modalOptions.useiFrame) {
      let doc = this.$refs.iframe.contentWindow.document
      doc.open()
      doc.write(this.$refs.modalContent.innerHTML)
      doc.close()
    }
  },
  methods: {
    checkClick (e) {
      if (Array.from(e.target.classList).includes('modal')) {
        this.$emit('dismiss')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Modal.vue